import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout, Menu, Dropdown } from 'antd';
import AntIcon from './AntIcon';

import { logout } from '../../auth/authActions';

class Header extends Component {
  headerRef = React.createRef();

  render() {
    const { email, logout } = this.props;

    const profileMenu = (
      <Menu>
        <Menu.Item key="logout">
          <div onClick={logout}>Logout</div>
        </Menu.Item>
      </Menu>
    );

    return (
      <Layout.Header className="header">
        <div ref={this.headerRef} className="profile-status">
          <Dropdown
            overlay={profileMenu}
            trigger={['click']}
            getPopupContainer={() => this.headerRef.current || document.body}
          >
            <button type="button" className="profile-status__trigger">
              <span className="profile-status__email">{email}</span>
              <AntIcon type="down" />
            </button>
          </Dropdown>
        </div>
      </Layout.Header>
    );
  }
}

export default connect(
  (state) => ({
    email: state.auth && state.auth.email ? state.auth.email : '',
  }),
  { logout },
)(Header);
